import { normalizeBadmintonCourtColour } from "../../../../sports/badminton/config/badmintonCourtColour";

const GREEN_FILL = "#1c8a4f";
const LINE = "#fff";

/** Indoor hardwood — warm boards + soft grain (presentation only). */
function WoodenDefs({ idPrefix, plankAlong = "y" }) {
  const plankW = 18;
  const light = "#c9a87a";
  const mid = "#b8956a";
  const dark = "#a67c52";
  return (
    <defs>
      <linearGradient id={`${idPrefix}-wood`} x1="0" y1="0" x2="0.12" y2="1">
        <stop offset="0%" stopColor="#d4b48a" />
        <stop offset="42%" stopColor={mid} />
        <stop offset="78%" stopColor="#a9845c" />
        <stop offset="100%" stopColor="#98704c" />
      </linearGradient>
      <pattern
        id={`${idPrefix}-planks`}
        width={plankAlong === "y" ? plankW * 3 : 48}
        height={plankAlong === "y" ? 48 : plankW * 3}
        patternUnits="userSpaceOnUse"
      >
        {plankAlong === "y" ? (
          <>
            <rect width={plankW} height="48" fill={light} />
            <rect x={plankW} width={plankW} height="48" fill={mid} />
            <rect x={plankW * 2} width={plankW} height="48" fill={dark} />
            <line
              x1={plankW}
              y1="0"
              x2={plankW}
              y2="48"
              stroke="#8a6a42"
              strokeWidth="0.6"
              opacity="0.55"
            />
            <line
              x1={plankW * 2}
              y1="0"
              x2={plankW * 2}
              y2="48"
              stroke="#8a6a42"
              strokeWidth="0.6"
              opacity="0.55"
            />
          </>
        ) : (
          <>
            <rect width="48" height={plankW} fill={light} />
            <rect y={plankW} width="48" height={plankW} fill={mid} />
            <rect y={plankW * 2} width="48" height={plankW} fill={dark} />
            <line
              x1="0"
              y1={plankW}
              x2="48"
              y2={plankW}
              stroke="#8a6a42"
              strokeWidth="0.6"
              opacity="0.55"
            />
            <line
              x1="0"
              y1={plankW * 2}
              x2="48"
              y2={plankW * 2}
              stroke="#8a6a42"
              strokeWidth="0.6"
              opacity="0.55"
            />
          </>
        )}
      </pattern>
      <filter
        id={`${idPrefix}-wood-grain`}
        x="0%"
        y="0%"
        width="100%"
        height="100%"
        filterUnits="objectBoundingBox"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.85"
          numOctaves="3"
          stitchTiles="stitch"
          result="noise"
        />
        <feColorMatrix
          in="noise"
          type="matrix"
          values="0 0 0 0 0.42
                  0 0 0 0 0.28
                  0 0 0 0 0.14
                  0 0 0 0.2 0"
          result="grain"
        />
        <feBlend in="SourceGraphic" in2="grain" mode="soft-light" />
      </filter>
      <radialGradient
        id={`${idPrefix}-wood-glow`}
        cx="50%"
        cy="48%"
        r="70%"
        fx="48%"
        fy="42%"
      >
        <stop offset="0%" stopColor="#e8d0a8" stopOpacity="0.22" />
        <stop offset="50%" stopColor={mid} stopOpacity="0" />
        <stop offset="100%" stopColor="#6e4a2e" stopOpacity="0.26" />
      </radialGradient>
    </defs>
  );
}

function CourtSurface({ surface, idPrefix, width, height }) {
  if (surface === "wooden") {
    return (
      <>
        <rect
          x="0"
          y="0"
          width={width}
          height={height}
          rx="16"
          fill={`url(#${idPrefix}-wood)`}
        />
        <rect
          x="0"
          y="0"
          width={width}
          height={height}
          rx="16"
          fill={`url(#${idPrefix}-planks)`}
          opacity="0.72"
          pointerEvents="none"
        />
        <rect
          x="0"
          y="0"
          width={width}
          height={height}
          rx="16"
          fill={`url(#${idPrefix}-wood)`}
          filter={`url(#${idPrefix}-wood-grain)`}
          opacity="0.55"
          pointerEvents="none"
        />
        <rect
          x="0"
          y="0"
          width={width}
          height={height}
          rx="16"
          fill={`url(#${idPrefix}-wood-glow)`}
          pointerEvents="none"
        />
      </>
    );
  }

  return (
    <rect x="0" y="0" width={width} height={height} rx="16" fill={GREEN_FILL} />
  );
}

function PortraitLines() {
  return (
    <>
      <rect
        x="0"
        y="0"
        width="200"
        height="439"
        rx="16"
        fill="none"
        stroke={LINE}
        strokeWidth="2"
        opacity=".85"
      />
      <line x1="15" y1="0" x2="15" y2="439" stroke={LINE} strokeWidth="1.4" opacity=".55" />
      <line x1="185" y1="0" x2="185" y2="439" stroke={LINE} strokeWidth="1.4" opacity=".55" />
      <line x1="0" y1="219.5" x2="200" y2="219.5" stroke={LINE} strokeWidth="3" opacity=".9" />
      <line x1="0" y1="25" x2="200" y2="25" stroke={LINE} strokeWidth="1.2" opacity=".5" />
      <line x1="0" y1="414" x2="200" y2="414" stroke={LINE} strokeWidth="1.2" opacity=".5" />
      <line x1="0" y1="154.5" x2="200" y2="154.5" stroke={LINE} strokeWidth="1.6" opacity=".7" />
      <line x1="0" y1="284.5" x2="200" y2="284.5" stroke={LINE} strokeWidth="1.6" opacity=".7" />
      <line x1="100" y1="0" x2="100" y2="154.5" stroke={LINE} strokeWidth="1.4" opacity=".65" />
      <line x1="100" y1="284.5" x2="100" y2="439" stroke={LINE} strokeWidth="1.4" opacity=".65" />
    </>
  );
}

function LandscapeLines() {
  return (
    <>
      <rect
        x="0"
        y="0"
        width="439"
        height="200"
        rx="16"
        fill="none"
        stroke={LINE}
        strokeWidth="2"
        opacity=".85"
      />
      <line x1="0" y1="15" x2="439" y2="15" stroke={LINE} strokeWidth="1.4" opacity=".55" />
      <line x1="0" y1="185" x2="439" y2="185" stroke={LINE} strokeWidth="1.4" opacity=".55" />
      <line x1="219.5" y1="0" x2="219.5" y2="200" stroke={LINE} strokeWidth="3" opacity=".9" />
      <line x1="25" y1="0" x2="25" y2="200" stroke={LINE} strokeWidth="1.2" opacity=".5" />
      <line x1="414" y1="0" x2="414" y2="200" stroke={LINE} strokeWidth="1.2" opacity=".5" />
      <line x1="154.5" y1="0" x2="154.5" y2="200" stroke={LINE} strokeWidth="1.6" opacity=".7" />
      <line x1="284.5" y1="0" x2="284.5" y2="200" stroke={LINE} strokeWidth="1.6" opacity=".7" />
      <line x1="0" y1="100" x2="154.5" y2="100" stroke={LINE} strokeWidth="1.4" opacity=".65" />
      <line x1="284.5" y1="100" x2="439" y2="100" stroke={LINE} strokeWidth="1.4" opacity=".65" />
    </>
  );
}

export function PortraitCourtSvg({ surface } = {}) {
  const colour = normalizeBadmintonCourtColour(surface);
  const idPrefix = "bdm-p";
  return (
    <svg className="court-svg" viewBox="0 0 200 439" preserveAspectRatio="none">
      {colour === "wooden" ? <WoodenDefs idPrefix={idPrefix} plankAlong="y" /> : null}
      <CourtSurface surface={colour} idPrefix={idPrefix} width={200} height={439} />
      <PortraitLines />
    </svg>
  );
}

export function LandscapeCourtSvg({ surface } = {}) {
  const colour = normalizeBadmintonCourtColour(surface);
  const idPrefix = "bdm-l";
  return (
    <svg className="court-svg" viewBox="0 0 439 200" preserveAspectRatio="none">
      {colour === "wooden" ? <WoodenDefs idPrefix={idPrefix} plankAlong="x" /> : null}
      <CourtSurface surface={colour} idPrefix={idPrefix} width={439} height={200} />
      <LandscapeLines />
    </svg>
  );
}
